import {Pipe, PipeTransform} from '@angular/core';
import {ICruiseDetailCabin} from '../../booking-flow/cruise/cruise-detail-page/interfaces/icruise-detail-cabin';
import {ICruiseDetailCabinByType} from '../../booking-flow/cruise/cruise-detail-page/interfaces/icruise-detail-cabin-by-type';
import mapGroupBy from '../../../utils/mapGroupBy';
import minBy from '../../../utils/minBy';
import * as Fares from '../../../../assets/data/cruisefares.json';

@Pipe({
  name: 'cabinsByType'
})
export class CabinsByTypePipe implements PipeTransform {

  transform(value: ICruiseDetailCabin[], onlyAvailableBestCabin: boolean = false, hasSomePromo: string[]): ICruiseDetailCabinByType[] {
    if (value) {
      const hasSpecialCosta = hasSomePromo.includes('WINTER_ESCAPE');
      const cabins = value.filter(x => !x.description.toLowerCase().includes('singola'));

      const ret: ICruiseDetailCabinByType[] = [];

      const cabinsByTypeMap = mapGroupBy(cabins, (x) => x.type);

      [...cabinsByTypeMap.keys()].forEach(x => {
        let bestCabin: ICruiseDetailCabin;

        // verifico se devo filtrare solo le bestCabin disponibili altrimenti, prendo a prescindere quella con il prezzo piu basso
        if (onlyAvailableBestCabin) {
          bestCabin = this.getCheapestPreferringAvailable(cabinsByTypeMap.get(x));
        } else {
          if(hasSpecialCosta){
            cabinsByTypeMap.get(x).forEach(cabin => {
              cabin.disable = cabin.fare === 'myCruise';
            })
            const myAllincCabins = cabinsByTypeMap.get(x).filter(cabin => cabin.fare === 'myAllinc');
            bestCabin = this.getCheapestPreferringAvailable(myAllincCabins);
          } else {
            // a cheaper but unavailable cabin (e.g. PInd after /category) would otherwise flag the whole type as unavailable
            bestCabin = this.getCheapestPreferringAvailable(cabinsByTypeMap.get(x));
          }
        }

        cabinsByTypeMap.get(x).forEach(cabin => {
          const fareInfo = this.getFareInfoFromCabin({
            cabin,
            tourOperatorId: 132 // dinamicizzare se vengono abilitati altri top oltre COSTA...
          });
          cabin.label = fareInfo?.label;
        });
        ret.push({
          type: x,
          bestCabin,
          cabins: this.getLabelFromFare(cabinsByTypeMap.get(x)),
          openCabin: false
        });
      });
      return ret.sort((a, b) => {
        return a.bestCabin.price > b.bestCabin.price ? 1 : -1;
      });
    }
    return [];
  }

  private getCheapestPreferringAvailable(cabins: ICruiseDetailCabin[]): ICruiseDetailCabin {
    const availableCabins = cabins?.filter((cabin) => cabin.available) || [];
    return availableCabins.length ? minBy(availableCabins, 'price') : minBy(cabins, 'price');
  }

  public getFareInfoFromCabin(params: { cabin: ICruiseDetailCabin; tourOperatorId: number }) {
    const topId = params.tourOperatorId.toString(10);
    const fare = this.normalizeFare(params.cabin?.fare);
    return this.getFareInfoFromFareName(fare, topId);
  }

  public getFareInfoFromFareName(fareName: string, topId: string) {
    const fare = this.normalizeFare(fareName);
    const fares: { [top: string]: any } = Fares;
    if (fares?.default[topId.toString()]) {
      return fares.default[topId.toString()][fare];
    }
    return undefined;
  }

  getLabelFromFare = (cabinsByTypeMap: any) => {
    cabinsByTypeMap.forEach(cabin => {
      this.normalizeFare(cabin.fare);
    });
    return cabinsByTypeMap;
  }
  private normalizeFare(fareName: string): string {
    return fareName
      .toUpperCase()
      .replace('COSTA', 'ALLINCL')
      .replace(/^(W|G)/, '')
      .replace(/^E/, 'S');
  }
}
